import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser, loginUser } from '../utils/apiServices';
import { AuthContext } from '../contexts/AuthContext';
import '../stylesheets/login.css';

function AuthForm() {
  const [document, setDocument] = useState('');
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [isRegister, setIsRegister] = useState(false);
  const [errors, setErrors] = useState({});
  const { user, login, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleDocumentChange = (event) => {
    setDocument(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleFullNameChange = (event) => {
    setFullName(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isRegister) {
      handleRegister();
    } else {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    try {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      const data = await loginUser(document, password);
      await login(data.access);
      setErrors({});
    } catch (error) {
      setErrors({ detail: error.response?.data?.detail || 'Error al iniciar sesión' });
    }
  };

  const handleRegister = async () => {
    try {
      await registerUser(document, email, fullName, password);
      handleLogin();
    } catch (error) {
      setErrors({ detail: error.response?.data?.detail || 'Error al registrar usuario' });
    }
  };

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  if (user) {
    return (
      <div className="welcome-unified">
        <div className="welcome-content-wrapper">
          <div className="welcome-icon-modern">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="9" y1="15" x2="15" y2="15"></line>
            </svg>
          </div>

          <h1 className="welcome-main-title">¡Bienvenido!</h1>
          <p className="welcome-subtitle">
            Crea y gestiona tus planes de negocios con asistencia de inteligencia artificial
          </p>

          <div className="welcome-intro-block">
            <h2 className="intro-title">¿Qué puedes hacer aquí?</h2>
            <p className="intro-text">
              Nuestra plataforma te acompaña en cada paso de la creación de tu plan de negocios. Con inteligencia artificial, recibe recomendaciones personalizadas y genera automáticamente un plan de acción priorizado.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📝</div>
              <h3>Editor por secciones</h3>
              <p>Completa las secciones clave: Resumen ejecutivo, Mercado, Sector, Propuesta de valor y más.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🤖</div>
              <h3>Sugerencias IA</h3>
              <p>Mejora tu contenido con recomendaciones específicas impulsadas por inteligencia artificial.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Plan de acción</h3>
              <p>Genera automáticamente un cronograma priorizado con entregables e indicadores de éxito.</p>
            </div>
          </div>

          <div className="cta-section">
            <Link to="/plans" className="cta-btn primary">
              Ir a mis Planes
            </Link>
          </div>

          <div className="welcome-footer-note">
            Plataforma de Herramientas Digitales - ICETEX
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <button onClick={() => navigate('/')} className="back-home-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            Volver al Inicio
          </button>
        </div>

        <div className="auth-card">
          <div className="auth-card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>

          <h1 className="auth-title">
            {isRegister ? 'Crear Cuenta' : 'Iniciar Sesión'}
          </h1>
          <p className="auth-subtitle">
            {isRegister 
              ? 'Regístrate para acceder a todas las herramientas de ICETEX' 
              : 'Accede a tu cuenta para continuar'}
          </p>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="document" className="form-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                Documento de Identidad
              </label>
              <input
                type="text"
                id="document"
                name="document"
                value={document}
                onChange={handleDocumentChange}
                required
                className="form-input"
                placeholder="Ingresa tu número de documento"
              />
            </div>

            {isRegister && (
              <>
                <div className="form-group">
                  <label htmlFor="fullName" className="form-label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    Nombre Completo
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={fullName}
                    onChange={handleFullNameChange}
                    required
                    className="form-input"
                    placeholder="Ingresa tu nombre completo"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    Correo Electrónico
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={handleEmailChange}
                    required
                    className="form-input"
                    placeholder="ejemplo@correo.com"
                  />
                </div>
              </>
            )}

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                Contraseña
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={handlePasswordChange}
                required
                className="form-input"
                placeholder="Ingresa tu contraseña"
              />
            </div>

            {errors.detail && (
              <div className="error-alert">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <p>{errors.detail}</p>
              </div>
            )}

            <button type="submit" className="auth-submit-btn">
              {isRegister ? 'Registrarme' : 'Iniciar Sesión'}
            </button>

            <button 
              type="button"
              onClick={() => {
                setIsRegister(!isRegister);
                setErrors({});
              }} 
              className="auth-toggle-btn"
            >
              {isRegister ? '¿Ya tienes una cuenta? Inicia sesión' : '¿No tienes cuenta? Regístrate aquí'}
            </button>

            {!isRegister && (
              <Link to="/forgot-password/" className="forgot-password-link">
                ¿Olvidaste tu contraseña?
              </Link>
            )}
          </form>
        </div>

        <div className="auth-footer">
          <p>Plataforma de Herramientas Digitales - ICETEX</p>
        </div>
      </div>
    </div>
  );
}

export default AuthForm;
